var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-921 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(921 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(889.496 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.508,255.364c0-.631-.438-1.008-1.212-1.008a2.628,2.628,0,0,0-.64.061v2.025a2.377,2.377,0,0,0,.519.04C107,256.483,107.508,256.066,107.508,255.364Z",
    transform: "translate(-70.809 -242.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.1,8.882h-.6V6a.42.42,0,0,0-.005-.054.478.478,0,0,0-.116-.315L46.6.167l0,0a.483.483,0,0,0-.1-.081L46.465.063a.5.5,0,0,0-.1-.04L46.343.014A.486.486,0,0,0,46.231,0H34.466a.975.975,0,0,0-.974.974V8.881h-.6A1.392,1.392,0,0,0,31.5,10.273V17.51A1.392,1.392,0,0,0,32.9,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.532a.975.975,0,0,0,.974-.974V18.9h.6a1.392,1.392,0,0,0,1.392-1.392V10.273A1.392,1.392,0,0,0,52.1,8.882ZM34.466.974H45.744V5.956a.487.487,0,0,0,.487.487h4.3V8.882H34.466Zm6.182,14.167v2.066H39.223v-6.86h1.811l1.425,2.514a19.8,19.8,0,0,1,1.119,2.351h.03a25.472,25.472,0,0,1-.132-2.86v-2H44.9v6.86H43.274L41.808,14.56a25.456,25.456,0,0,1-1.192-2.422l-.03.01C40.628,13.054,40.648,14.021,40.648,15.141ZM33.31,17.207V10.439a12.712,12.712,0,0,1,2.1-.142,3.29,3.29,0,0,1,2.1.55,2.006,2.006,0,0,1,.733,1.588,2.191,2.191,0,0,1-.631,1.628,3.18,3.18,0,0,1-2.229.723,3.95,3.95,0,0,1-.529-.03v2.453H33.31Zm17.223,6.386H34.466V18.9H50.532v4.691Zm1.445-6.7a7.686,7.686,0,0,1-2.29.387,3.823,3.823,0,0,1-2.789-.926,3.32,3.32,0,0,1-.967-2.494c.01-2.28,1.669-3.582,3.918-3.582a4.719,4.719,0,0,1,1.9.336l-.325,1.242a3.8,3.8,0,0,0-1.6-.3,2.076,2.076,0,0,0-2.269,2.219,2.247,2.247,0,0,0,2.921,2.147V14.489H49.422V13.278h2.555v3.613Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.c99d3b9e559165ca6bc4ea09f58fcd2b.svg";
export { ForwardRef as ReactComponent };